/**
 * CookieBanner – baner zgody na cookies
 * Blokuje skrypt analityczny do czasu wyrażenia zgody.
 * Przechowuje wybór w localStorage.
 */
import { useState, useEffect } from 'react';
import { Link } from 'wouter';

const STORAGE_KEY = 'pphu_cookie_consent';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      // Pokaż baner po krótkim opóźnieniu
      const t = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(t);
    }
    if (stored === 'accepted') {
      enableAnalytics();
    }
  }, []);

  function enableAnalytics() {
    // Aktywuj skrypt analityczny Umami jeśli jeszcze nie załadowany
    const scriptId = 'umami-analytics';
    if (!document.getElementById(scriptId)) {
      const s = document.createElement('script');
      s.id = scriptId;
      s.defer = true;
      s.src = (import.meta.env.VITE_ANALYTICS_ENDPOINT || '') + '/umami';
      s.setAttribute('data-website-id', import.meta.env.VITE_ANALYTICS_WEBSITE_ID || '');
      document.body.appendChild(s);
    }
  }

  const handleAccept = () => {
    localStorage.setItem(STORAGE_KEY, 'accepted');
    enableAnalytics();
    setVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem(STORAGE_KEY, 'rejected');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label="Zgoda na pliki cookies"
      aria-live="polite"
      className="cookie-banner"
      style={{
        position: 'static',
        backgroundColor: '#111B30',
        borderTop: '3px solid #F5C400',
        padding: '1.25rem 1.5rem',
        paddingBottom: 'calc(1.25rem + env(safe-area-inset-bottom, 0px))',
      }}
    >
      <div className="cookie-banner__content" style={{
        maxWidth: '1280px',
        margin: '0 auto',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '1rem',
        justifyContent: 'space-between',
      }}>
        <p className="cookie-banner__text" style={{
          fontFamily: "'Manrope', sans-serif",
          fontSize: '0.85rem',
          color: 'rgba(248,248,246,0.8)',
          margin: 0,
          flex: '1 1 300px',
          lineHeight: 1.6,
        }}>
          Ta strona używa plików cookies. Niezbędne cookies działają zawsze. Analityczne cookies (pomiar ruchu) aktywujemy tylko za Twoją zgodą.{' '}
          <Link
            href="/polityka-prywatnosci"
            style={{ color: '#F5C400', textDecoration: 'underline', fontWeight: 600 }}
            onClick={() => setVisible(false)}
          >
            Polityka prywatności
          </Link>
        </p>
        <div className="cookie-banner__actions" style={{ display: 'flex', gap: '0.75rem', flexShrink: 0, flexWrap: 'wrap' }}>
          <button
            onClick={handleReject}
            className="cookie-banner__button"
            style={{
              fontFamily: "'Manrope', sans-serif",
              fontWeight: 700,
              fontSize: '0.8rem',
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              padding: '0.6rem 1.25rem',
              backgroundColor: 'transparent',
              border: '1px solid rgba(248,248,246,0.25)',
              color: 'rgba(248,248,246,0.6)',
              borderRadius: '2px',
              cursor: 'pointer',
              transition: 'border-color 150ms, color 150ms',
            }}
            onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.borderColor = 'rgba(248,248,246,0.5)'; (e.currentTarget as HTMLElement).style.color = '#F8F8F6'; }}
            onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.borderColor = 'rgba(248,248,246,0.25)'; (e.currentTarget as HTMLElement).style.color = 'rgba(248,248,246,0.6)'; }}
          >
            Tylko niezbędne
          </button>
          <button
            onClick={handleAccept}
            className="cookie-banner__button"
            style={{
              fontFamily: "'Manrope', sans-serif",
              fontWeight: 700,
              fontSize: '0.8rem',
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              padding: '0.6rem 1.25rem',
              backgroundColor: '#F5C400',
              border: '1px solid #F5C400',
              color: '#111B30',
              borderRadius: '2px',
              cursor: 'pointer',
              transition: 'background-color 150ms',
            }}
            onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.backgroundColor = '#D4A800'; }}
            onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.backgroundColor = '#F5C400'; }}
          >
            Akceptuję wszystkie
          </button>
        </div>
      </div>
    </div>
  );
}
